export class DateFilter {
  public periodFrom?: Date;
	public periodTo?: Date;
}
